'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stateSpliter = require('coact-utils/stateSpliter');

var _stateSpliter2 = _interopRequireDefault(_stateSpliter);

var _ConditionEditor = require('./ConditionEditor');

var _ConditionEditor2 = _interopRequireDefault(_ConditionEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function QueryEditor(props) {
  var conditionSpecByKey = props.conditionSpecByKey,
      fields = props.fields,
      value = props.value,
      onChange = props.onChange;

  var linkState = (0, _stateSpliter2.default)(value, onChange);

  return _react2.default.createElement(
    'div',
    null,
    fields.map(function (key) {
      return _react2.default.createElement(_ConditionEditor2.default, _extends({
        key: key
      }, conditionSpecByKey[key], linkState(key, {}, 'query', 'setQuery')));
    })
  );
}
var object = _propTypes2.default.object,
    func = _propTypes2.default.func,
    array = _propTypes2.default.array;

QueryEditor.propTypes = {
  fields: array.isRequired,
  value: object,
  onChange: func.isRequired,
  conditionSpecByKey: object.isRequired
};

exports.default = QueryEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/QueryEditor.js
// module id = 1664
// module chunks = 0